/**
 * useTranslateText Hook
 * On-demand translation of user-generated content via TanStack Query.
 * Results are cached by (text, targetLang) to avoid redundant API calls.
 */

import { useQuery } from '@tanstack/react-query'
import { translateText } from '@/lib/services/translationService'

export const TRANSLATION_KEY = (text: string, lang: string) =>
  ['translation', lang, text] as const

export function useTranslateText(
  text: string,
  targetLang: string,
  enabled: boolean
) {
  const query = useQuery({
    queryKey: TRANSLATION_KEY(text, targetLang),
    queryFn: () => translateText(text, targetLang),
    enabled: enabled && !!text && targetLang !== 'en',
    staleTime: Infinity,
    gcTime: 30 * 60 * 1000,
    retry: 1,
  })

  return {
    translatedText: query.data?.translatedText ?? null,
    isLoading: query.isFetching,
    error: query.error,
  }
}
